import './scss/index.scss';

import ComponentsFactory from 'foundation/components-factory';
import VideoComponent from './js/video.component';

ComponentsFactory.getInstance().define('video', VideoComponent);
